import { enumFillMode, enumProfileColType, enumProfileRowType } from "../constants";
import { GetFieldDefBy } from "../utils/GetFieldDefBy";
import { QProfileCol } from "./QProfileCol";
import { QXMLObject } from "./QXMLObject";

export class QProfileRow extends QXMLObject {
  constructor() {
    //    this.fObjDB = null;
    super();
    this.fRowType = null;
    this.fFieldDef = null;
    this.fFieldDefID = null;

    this.fDocMgr = null;
    this.fProfileCol1 = null;
    this.fProfileCol2 = null;
    this.SetXMLElementName("profilerow");
  }

  InitProfileRow(rowType, fieldDef) {
    this.fRowType = rowType;
    this.SetFieldDef(fieldDef);

    this.fProfileCol1 = new QProfileCol();
    this.fProfileCol1.InitProfileCol();

    var freeText = null;
    var colType1 = null;
    var colType2 = null;

    switch (rowType) {
      case enumProfileRowType.standard:
        colType1 = enumProfileColType.label;
        colType2 = enumProfileColType.value;
        break;
      case enumProfileRowType.freeTextSingle:
        colType1 = enumProfileColType.freetext;
        freeText = "";
        break;
      case enumProfileRowType.freeTextDouble:
        colType1 = enumProfileColType.freetext;
        colType2 = enumProfileColType.freetext;
        freeText = "";
        break;
      case enumProfileRowType.object:
        colType1 = enumProfileColType.label;
        colType2 = enumProfileColType.object;
        break;
    }
    //TODO: Fixing this is a 'later' issue.
    this.fProfileCol1.SetProperties(
      colType1,
      "#DEEBF6",
      enumFillMode.solidFill,
      "#000000",
      true,
      false,
      freeText
    );

    if (colType2 != null) {
      this.fProfileCol2 = new QProfileCol();
      this.fProfileCol2.InitProfileCol();
      var freeText2 = null;
      if (colType2 == enumProfileColType.freetext) freeText2 = "";

      this.fProfileCol2.SetProperties(
        colType2,
        "#FFFFFF",
        enumFillMode.noFill,
        "#000000",
        false,
        false,
        freeText2
      );
    }
  }

  SetDocMgrRef(docMgrRef) {
    this.fDocMgr = docMgrRef;
    //  this.fObjDB = objDB;
  }

  GetObjDB() {
    var curDoc = this.fDocMgr.GetCurrentDoc();
    return curDoc.GetObjDB();
    //  this.fObjDB = objDB;
  }

  GetRowType() {
    return this.fRowType;
  }

  GetFieldDef() {
    if (this.fFieldDef == null) {
      var fieldID = this.fFieldDefID;
      if (fieldID != null) {
        var o = this.GetObjDB();
        var theClass = o.GetClassByName("Box");
        this.fFieldDef = theClass.GetFieldDefByID(fieldID);
      }
    }
    return this.fFieldDef;
  }

  SetFieldDef(fieldDef) {
    this.fFieldDef = fieldDef;
  }

  GetCol(index) {
    if (index == 0) return this.fProfileCol1;
    else if (index == 1) return this.fProfileCol2;

    return null;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("rowtype", this.fRowType, stream);
    var f = this.GetFieldDef();
    if (f != null) {
      var fieldID = f.GetFieldID();
      this.OutputSimpleElement("fieldid", fieldID, stream);
    }
  }

  OutputToJSON(json) {
    var row = {};
    row["type"] = this.fRowType;

    var f = this.GetFieldDef();
    if (f != null) {
      var fieldID = f.GetFieldID();
      row["fieldID"] = fieldID;
    }
    //TODO: In some places we're returning, in others we're mutating the object. Concern?

    row["col1"] = this.fProfileCol1.OutputToJSON(json);
    if (this.fProfileCol2 != null) row["col2"] = this.fProfileCol2.OutputToJSON(json);

    return row;
  }

  OutputChildElements(stream) {
    this.fProfileCol1.OutputToXML(stream);
    if (this.fProfileCol2 != null) this.fProfileCol2.OutputToXML(stream);
  }

  LoadFromJSON(JSON) {
    this.fRowType = JSON["type"];
    if (JSON["fieldID"]) this.fFieldDefID = JSON["fieldID"];

    var col1 = JSON["col1"];
    this.fProfileCol1 = new QProfileCol();
    this.fProfileCol1.InitProfileCol();
    this.fProfileCol1.LoadFromJSON(col1);

    if (JSON["col2"]) {
      this.fProfileCol2 = new QProfileCol();
      this.fProfileCol2.InitProfileCol();
      this.fProfileCol2.LoadFromJSON(JSON["col2"]);
    }
  }

  LoadChildElements(objTree) {
    this.fRowType = objTree.GetValueForChild("rowtype", true);

    //  var o = this.GetObjDB();
    //  var theClass = o.GetClassByName("Box");
    var fieldID = objTree.GetValueForChild("fieldid", false);
    if (fieldID != null) this.fFieldDefID = fieldID;

    var eList = objTree.GetChildOfTypeList("profilecol");
    var numCols = eList.length;
    this.fProfileCol1 = new QProfileCol();
    this.fProfileCol1.InitProfileCol();
    this.fProfileCol1.LoadFromXML(eList[0]);

    if (numCols > 1) {
      this.fProfileCol2 = new QProfileCol();
      this.fProfileCol2.InitProfileCol();
      this.fProfileCol2.LoadFromXML(eList[1]);
    }
  }

  CopyFormat(origRow) {
    this.fProfileCol1.CopyFormat(origRow.fProfileCol1);

    if (this.fProfileCol2) this.fProfileCol2.CopyFormat(origRow.fProfileCol2);
  }

  Clone() {
    var c = new QProfileRow();

    c.fDocMgr = this.fDocMgr;
    c.fRowType = this.fRowType;
    c.fFieldDef = this.fFieldDef;
    c.fFieldDefID = this.fFieldDefID;

    c.fProfileCol1 = this.fProfileCol1.Clone();
    c.fProfileCol2 = this.fProfileCol2.Clone();

    return c;
  }
}
